/* eslint-disable */
import React from 'react';

/**
 * Bouton Paramètres flottant global
 * S'affiche sur toutes les pages sauf la page d'accueil principale
 */
const GlobalSettingsButton = ({ onClick, isHidden }) => {
  if (isHidden) return null;

  const buttonStyle = {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    transition: 'all 0.3s ease',
    zIndex: 9998
  };

  const buttonHoverStyle = {
    transform: 'scale(1.1)',
    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.5)'
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      style={{...buttonStyle, ...(isHovered ? buttonHoverStyle : {})}}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title="Paramètres"
    >
      ⚙️
    </button>
  );
};

export default GlobalSettingsButton;
